export default __webpack_public_path__ + "images/RR.c9954c5.png";